var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1066(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1250 1250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M452.678,359.686c-5.35,27.004 -8.469,49.498 -8.469,77.981c0,166.143 97.44,312.689 217.458,374.664c-167.231,0 -312.379,-82.712 -384.053,-203.534l-2.581,3.335c-58.808,23.529 -117.032,69.668 -116.177,183.469c1.177,156.777 170.401,169.904 170.401,169.904l560.224,0.217c0,-0 195.695,-22.573 198.553,-231.768c3.007,-220.119 -210.356,-233.86 -216.109,-244.859c-42.731,-81.699 -71.782,-191.829 -259.168,-192.996c-71.411,-0.444 -121.246,24.957 -160.079,63.587Z",
    style: {
      fill: "#e5e5e5"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M263.28,598.335l4.788,-3.612c-64.531,25.819 -128.899,76.144 -127.962,201.019c1.301,173.294 187.701,188.457 187.701,188.457c0.48,0.038 0.962,0.056 1.443,0.056l560.224,0.217c0.72,0 1.44,-0.041 2.156,-0.124c-0,0 212.062,-23.977 215.152,-250.138c2.881,-210.875 -178.381,-245.974 -221.036,-259.215c-25.632,-50.132 -48.4,-108.78 -101.849,-148.972c-37.795,-28.421 -90.763,-48.174 -171.023,-48.673c-77.386,-0.482 -131.337,27.181 -173.419,69.043c-2.644,2.63 -4.444,5.99 -5.169,9.648c-5.6,28.265 -8.827,51.814 -8.827,81.626c0,143.959 70.25,273.696 165.749,350.744c-129.807,-19.264 -239.144,-90.862 -297.468,-189.18l-16.126,28.316l-14.334,-29.212Zm8.08,35.768c77.653,117.404 223.297,196.978 390.307,196.978c8.65,0 16.178,-5.917 18.22,-14.323c2.042,-8.406 -1.931,-17.118 -9.617,-21.087c-114.615,-59.185 -207.311,-199.341 -207.311,-358.004c0,-25.123 2.578,-45.356 7.003,-68.631l0.004,-0.004c34.991,-33.16 79.703,-54.575 142.674,-54.183c69.649,0.434 115.921,16.482 148.719,41.145c50.508,37.981 69.492,95.027 93.952,141.791c1.421,2.719 4.104,6.354 9.463,9.207c4.038,2.15 13.659,4.938 27.039,8.708c53.155,14.977 179.697,55.126 177.472,217.998c-2.513,184.024 -166.965,211.279 -181,213.27c-0.025,0.003 -558.234,-0.212 -558.234,-0.212c-11.052,-1.014 -151.434,-16.542 -152.446,-151.296c-0.719,-95.845 44.566,-138.786 93.755,-161.357Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M661.667,63.004c-238.249,-0 -431.678,167.881 -431.678,374.663c0,206.783 193.429,374.664 431.678,374.664c-120.018,-61.975 -217.458,-208.521 -217.458,-374.664c0,-166.142 97.44,-312.688 217.458,-374.663Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "37.5px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M705.275,1118.49l-160.5,-0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.381,1048.22l-80.25,138.997",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.15,1187.02l-80.25,-138.997",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1066);
export default __webpack_public_path__ + "static/media/1066.170555d2ccf23b9224c2fcdc492ad974.svg";
export { ForwardRef as ReactComponent };